import { generalServiceV1API } from '@/store/api-instance'
import { IEstrattoResponse, IRiepilogoResponse, IDettaglioResponse, IEstrattoDatesResponse, IEstrattoMaterialsResponse } from '@/store/modules/estratto/interfaces/api/IEstrattoResponse'
import { IEstrattoRequest, IRiepilogoRequest, IDettaglioRequest, IEstrattoDatesRequest, IEstrattoMaterialsRequest, IEstrattoSaveRequest, IEstrattoExportRequest } from '@/store/modules/estratto/interfaces/api/IEstrattoRequest'
import { AxiosResponse } from 'axios'

export const estrattoAPI = {
  async fetchEstrattoConto (dto: IEstrattoRequest): Promise<IEstrattoResponse> {
    const response: AxiosResponse = await generalServiceV1API.get<IEstrattoResponse>('ordersstatement', { params: dto })
    return response.data
  },
  async fetchRiepilogo (dto: IRiepilogoRequest): Promise<IRiepilogoResponse> {
    const response: AxiosResponse = await generalServiceV1API.get<IRiepilogoResponse>('ordersstatement/materials', { params: dto })
    return response.data
  },
  async fetchDettaglio (dto: IDettaglioRequest): Promise<IDettaglioResponse> {
    const response: AxiosResponse = await generalServiceV1API.get<IDettaglioResponse>('ordersstatement/movements', { params: dto })
    return response.data
  },
  async fetchDates (dto: IEstrattoDatesRequest): Promise<IEstrattoDatesResponse> {
    const response: AxiosResponse = await generalServiceV1API.get<IEstrattoDatesResponse>('emptiesreconciliation/dates', { params: dto })
    return response.data
  },
  async fetchMaterials (dto: IEstrattoMaterialsRequest): Promise<IEstrattoMaterialsResponse> {
    const response: AxiosResponse = await generalServiceV1API.get<IEstrattoMaterialsResponse>('emptiesreconciliation/materials', { params: dto })
    return response.data
  },
  async saveMaterials (dto: IEstrattoSaveRequest): Promise<void> {
    await generalServiceV1API.post('emptiesreconciliation/save', dto)
  },
  async exportMaterials (dto: IEstrattoExportRequest): Promise<Blob> {
    const response = await generalServiceV1API.get('emptiesreconciliation/exportxls', { params: dto, responseType: 'blob' })
    return response.data
  }
}
